export default function ComparisonSection() {
  const comparisons = [
    {
      category: 'Timeline',
      traditional: '6-12 months average',
      trex: '7-14 days',
      advantage: 'Save up to a year of time'
    },
    {
      category: 'Commissions',
      traditional: '6% of sale price',
      trex: '$0 - No commissions',
      advantage: 'Save $60,000 on $1M sale'
    },
    {
      category: 'Repairs Required',
      traditional: '$20,000-$100,000+',
      trex: '$0 - Buy as-is',
      advantage: 'Save tens of thousands'
    },
    {
      category: 'Showings',
      traditional: 'Multiple showings over months',
      trex: 'One property visit',
      advantage: 'Minimal disruption'
    },
    {
      category: 'Financing Risk',
      traditional: 'High - deals fall through',
      trex: 'Zero - cash purchase',
      advantage: 'Guaranteed closing'
    },
    {
      category: 'Tenant Issues',
      traditional: 'You handle everything',
      trex: 'We handle everything',
      advantage: 'No tenant headaches'
    },
    {
      category: 'Closing Costs',
      traditional: '2-3% of sale price',
      trex: 'Minimal - we cover most',
      advantage: 'Save thousands more'
    },
    {
      category: 'Paperwork',
      traditional: 'You coordinate everything',
      trex: 'We handle all details',
      advantage: 'Stress-free process'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Comparison
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Traditional Sale vs. Selling to Apartment Buyers
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See the clear advantages of selling my apartments to professional cash buyers versus listing with a traditional real estate agent.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-gray-900 to-gray-800">
                  <th className="px-8 py-6 text-left text-white font-bold text-lg">Factor</th>
                  <th className="px-8 py-6 text-left text-white font-bold text-lg">Traditional Sale</th>
                  <th className="px-8 py-6 text-left text-teal-400 font-bold text-lg">T-Rex Real Estate</th>
                  <th className="px-8 py-6 text-left text-white font-bold text-lg">Your Advantage</th>
                </tr>
              </thead>
              <tbody>
                {comparisons.map((item, index) => (
                  <tr 
                    key={index}
                    className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-teal-50 transition-colors`}
                  >
                    <td className="px-8 py-6 font-bold text-gray-900">{item.category}</td>
                    <td className="px-8 py-6 text-gray-600">
                      <div className="flex items-center space-x-2">
                        <i className="ri-close-circle-fill text-red-500"></i>
                        <span>{item.traditional}</span>
                      </div>
                    </td>
                    <td className="px-8 py-6 text-gray-900 font-semibold">
                      <div className="flex items-center space-x-2">
                        <i className="ri-checkbox-circle-fill text-teal-600"></i>
                        <span>{item.trex}</span>
                      </div>
                    </td>
                    <td className="px-8 py-6 text-teal-700 font-medium">{item.advantage}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 text-white text-center">
            <div className="text-5xl font-bold mb-3">$80K+</div>
            <div className="text-xl font-semibold mb-2">Average Savings</div>
            <div className="text-teal-100">On a $1M apartment sale compared to traditional methods</div>
          </div>
          <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 text-white text-center">
            <div className="text-5xl font-bold mb-3">11 Months</div>
            <div className="text-xl font-semibold mb-2">Time Saved</div>
            <div className="text-teal-100">Average time saved versus traditional 12-month sale process</div>
          </div>
          <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 text-white text-center">
            <div className="text-5xl font-bold mb-3">Zero</div>
            <div className="text-xl font-semibold mb-2">Hassles</div>
            <div className="text-teal-100">No repairs, showings, or tenant coordination required</div>
          </div>
        </div>
      </div>
    </section>
  );
}